import styles from "./styles.module.css"

function DataCard({ value, title }) {
    return (
        <div className={styles.cardContainer}>
            {title === "Número de Parcelas" ? <div className={styles.value}>{value}</div> : <div className={styles.value}>{`${value.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            })}`}</div>}
            <div className={styles.cardTitle}>{title}</div>
        </div>
    )
}

export default DataCard